/**
 * @file legal-presets.ts
 * @description Заготовки нового документа (phase10.5.X; phase19.16 — адреса
 * и названия обязательных документов из shared `LEGAL_SYSTEM_SLUGS`, SB140).
 *
 * Заготовка подставляет адрес, название и (для текста) черновик из
 * `legal-drafts.ts` — вычитка юристом обязательна. Для PDF и групп
 * заготовок нет: оферта и политика ПДн бывают только текстом (SB140).
 */

import { LEGAL_SYSTEM_SLUGS, type LegalDocumentKind } from "@chaiberi/shared";

import { LEGAL_DRAFTS_BY_PRESET } from "../legal-drafts";

export interface LegalDocPreset {
  /** Ключ заготовки; `custom` — свой документ без подстановки. */
  key: string;
  slug: string;
  title: string;
  /** Черновик текста (HTML) или null. */
  draftHtml: string | null;
}

const system = (slug: keyof typeof LEGAL_SYSTEM_SLUGS): LegalDocPreset => ({
  key: slug,
  slug,
  title: LEGAL_SYSTEM_SLUGS[slug].label,
  draftHtml: LEGAL_DRAFTS_BY_PRESET[slug] ?? null,
});

/** Заготовки текстового документа: обязательные (SB140), cookie и «свой». */
export const LEGAL_TEXT_PRESETS: readonly LegalDocPreset[] = [
  system("offer"),
  system("privacy-policy"),
  system("personal-data-consent"),
  system("returns-notice"),
  { key: "cookies", slug: "cookies", title: "Уведомление об использовании cookie", draftHtml: LEGAL_DRAFTS_BY_PRESET.cookies ?? null },
  { key: "custom", slug: "", title: "", draftHtml: null },
];

/** Заготовки для вида: у PDF и групп — только «свой». */
export function legalPresetsFor(kind: LegalDocumentKind): readonly LegalDocPreset[] {
  return kind === "TEXT" ? LEGAL_TEXT_PRESETS : [];
}
